import { render } from "./OverviewListing.vue?vue&type=template&id=e198b1d2&scoped=true"
import script from "./OverviewListing.vue?vue&type=script&lang=js"
export * from "./OverviewListing.vue?vue&type=script&lang=js"

import "./OverviewListing.vue?vue&type=style&index=0&id=e198b1d2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e198b1d2"]])

export default __exports__